var map = {
	"./abalone.svg": 97591,
	"./acornsquash.svg": 28945,
	"./alcohol.svg": 43063,
	"./alfalfasprouts.svg": 43042,
	"./almonds.svg": 89285,
	"./apples.svg": 1882,
	"./apricots.svg": 32068,
	"./artichokes.svg": 41382,
	"./arugula.svg": 62838,
	"./asparagus.svg": 62852,
	"./avocados.svg": 2463,
	"./bacon.svg": 86268,
	"./bagel.svg": 91536,
	"./bananas.svg": 87175,
	"./bean.svg": 1523,
	"./beansprouts.svg": 18793,
	"./beef.svg": 7140,
	"./beetgreens.svg": 36265,
	"./beets.svg": 64666,
	"./beverage.svg": 74170,
	"./blackberries.svg": 76586,
	"./blondies.svg": 39157,
	"./blueberries.svg": 30009,
	"./bokchoy.svg": 7856,
	"./boysenberries.svg": 39581,
	"./brazilnuts.svg": 97971,
	"./bread.svg": 22575,
	"./broccoli.svg": 5368,
	"./broccolirabe.svg": 49680,
	"./brownies.svg": 73432,
	"./brusselssprouts.svg": 54110,
	"./butter.svg": 86707,
	"./butternutsquash.svg": 20933,
	"./cake.svg": 45333,
	"./candy.svg": 39674,
	"./cantaloupe.svg": 98089,
	"./capers.svg": 32565,
	"./caramel.svg": 92698,
	"./carrots.svg": 79621,
	"./cashews.svg": 15597,
	"./cassava.svg": 40313,
	"./cauliflower.svg": 89704,
	"./celery.svg": 94811,
	"./cheese.svg": 62230,
	"./cherries.svg": 84034,
	"./chicken.svg": 25616,
	"./chickpea.svg": 31919,
	"./chilepeppers.svg": 89003,
	"./chives.svg": 45989,
	"./chocolate.svg": 58739,
	"./chocolatechips.svg": 43642,
	"./chorizo.svg": 38899,
	"./churro.svg": 99652,
	"./cinnamonroll.svg": 19097,
	"./clams.svg": 36667,
	"./clementines.svg": 94414,
	"./cobbler.svg": 56714,
	"./coconutmeat.svg": 73541,
	"./coldcut.svg": 43515,
	"./collardgreens.svg": 83288,
	"./cookies.svg": 2704,
	"./corn.svg": 61051,
	"./cottagecheese.svg": 84809,
	"./crab.svg": 68639,
	"./cranberries.svg": 63675,
	"./crayfish.svg": 10258,
	"./cream.svg": 59151,
	"./cremebrulee.svg": 27602,
	"./crepe.svg": 22132,
	"./croissant.svg": 8161,
	"./cucumber.svg": 14973,
	"./cupcake.svg": 79697,
	"./currants.svg": 73583,
	"./dairy.svg": 58172,
	"./date.svg": 59269,
	"./dough.svg": 92660,
	"./doughnuts.svg": 92592,
	"./dragonfruit.svg": 55852,
	"./driedfruit.svg": 18579,
	"./driedherb.svg": 52304,
	"./eclair.svg": 37317,
	"./edamame.svg": 73081,
	"./eggplant.svg": 31659,
	"./eggs.svg": 39043,
	"./endive.svg": 79746,
	"./englishmuffin.svg": 65158,
	"./escarole.svg": 28365,
	"./fatorsugar.svg": 13245,
	"./fennel.svg": 2357,
	"./figs.svg": 45484,
	"./fish.svg": 17779,
	"./flour.svg": 52037,
	"./food.svg": 5421,
	"./frenchfries.svg": 82156,
	"./frozenyogurt.svg": 11329,
	"./fruit.svg": 29251,
	"./fudge.svg": 16708,
	"./garlic.svg": 31455,
	"./gelatindessert.svg": 37165,
	"./gelato.svg": 24691,
	"./ginger.svg": 21033,
	"./gluten.svg": 25450,
	"./goat.svg": 22044,
	"./gooseberries.svg": 48862,
	"./grain.svg": 10212,
	"./grapefruit.svg": 16908,
	"./grapes.svg": 29473,
	"./greenbeans.svg": 23107,
	"./greenbellpepper.svg": 93979,
	"./greencabbage.svg": 53059,
	"./greenonions.svg": 99442,
	"./groundmeat.svg": 74185,
	"./guavas.svg": 47916,
	"./ham.svg": 33267,
	"./hazelnuts.svg": 11627,
	"./heartofpalm.svg": 99846,
	"./herb.svg": 17504,
	"./honeydew.svg": 3154,
	"./icecream.svg": 61148,
	"./jalapenopeppers.svg": 54916,
	"./jerky.svg": 37430,
	"./jicama.svg": 40960,
	"./kale.svg": 12524,
	"./kiwi.svg": 51437,
	"./kohlrabi.svg": 65691,
	"./lamb.svg": 2181,
	"./leafygreen.svg": 29203,
	"./leeks.svg": 1257,
	"./lemons.svg": 23097,
	"./lentil.svg": 57573,
	"./lentils.svg": 39006,
	"./lettuce.svg": 50011,
	"./limes.svg": 97871,
	"./lobster.svg": 58786,
	"./lychee.svg": 51584,
	"./macadamias.svg": 47752,
	"./mangos.svg": 21644,
	"./mayonnaise.svg": 67337,
	"./milk.svg": 7444,
	"./muffin.svg": 79982,
	"./mussels.svg": 86771,
	"./mustardgreens.svg": 23799,
	"./napacabbage.svg": 77586,
	"./nectarines.svg": 39891,
	"./noodles.svg": 80789,
	"./nut.svg": 73956,
	"./nutmilk.svg": 36541,
	"./octopus.svg": 57258,
	"./oil.svg": 24409,
	"./okra.svg": 32052,
	"./olives.svg": 92741,
	"./onions.svg": 94551,
	"./oranges.svg": 52540,
	"./organmeat.svg": 21375,
	"./other.svg": 4195,
	"./oysters.svg": 706,
	"./pancakes.svg": 23921,
	"./papaya.svg": 55855,
	"./parsley.svg": 89183,
	"./parsnips.svg": 14641,
	"./passionfruit.svg": 8806,
	"./pasta.svg": 3464,
	"./pea.svg": 99355,
	"./peaches.svg": 67878,
	"./peanutbutter.svg": 75016,
	"./peanuts.svg": 33027,
	"./pears.svg": 28418,
	"./pecan.svg": 17444,
	"./pepper.svg": 29749,
	"./pepperoni.svg": 26421,
	"./persimmon.svg": 34181,
	"./pickle.svg": 5047,
	"./pie.svg": 45755,
	"./pimento.svg": 87809,
	"./pineapple.svg": 95075,
	"./pinenuts.svg": 14231,
	"./pistachios.svg": 64338,
	"./pizza.svg": 74671,
	"./plums.svg": 30804,
	"./pluot.svg": 62857,
	"./pomegranate.svg": 68380,
	"./pork.svg": 70107,
	"./portabellamushrooms.svg": 37146,
	"./potatochips.svg": 64959,
	"./potatognocchi.svg": 62239,
	"./prawns.svg": 21314,
	"./protein.svg": 50464,
	"./proteinpowder.svg": 99679,
	"./pudding.svg": 5194,
	"./pumpkin.svg": 77657,
	"./quark.svg": 39991,
	"./radicchio.svg": 74585,
	"./radishes.svg": 5218,
	"./raisin.svg": 65775,
	"./rambutan.svg": 38101,
	"./raspberries.svg": 98255,
	"./recipe.svg": 36823,
	"./redbellpepper.svg": 54143,
	"./redcabbage.svg": 28407,
	"./redpotato.svg": 20237,
	"./rhubarb.svg": 66673,
	"./ribs.svg": 57659,
	"./rice.svg": 61886,
	"./russetpotato.svg": 34426,
	"./rutabaga.svg": 4416,
	"./salmon.svg": 42295,
	"./sauce.svg": 76844,
	"./sauerkraut.svg": 27478,
	"./scallops.svg": 88820,
	"./seaweed.svg": 17103,
	"./seed.svg": 78598,
	"./serranopepper.svg": 10557,
	"./shallots.svg": 48187,
	"./shellfish.svg": 46645,
	"./shiitakemushrooms.svg": 93746,
	"./sorbet.svg": 25088,
	"./sourcream.svg": 35782,
	"./soy.svg": 42770,
	"./spaghettisquash.svg": 37071,
	"./spice.svg": 11255,
	"./spinach.svg": 66193,
	"./squid.svg": 9443,
	"./starfruit.svg": 79163,
	"./stock.svg": 41455,
	"./strawberries.svg": 89014,
	"./strudel.svg": 65544,
	"./summersquash.svg": 44901,
	"./sweetener.svg": 16069,
	"./sweetpotato.svg": 77232,
	"./swisschard.svg": 27362,
	"./tangerine.svg": 66792,
	"./taro.svg": 93233,
	"./tilapia.svg": 39767,
	"./tomatillo.svg": 50142,
	"./tomatoes.svg": 19603,
	"./tortilla.svg": 54994,
	"./tuna.svg": 10595,
	"./turkey.svg": 14699,
	"./turnipgreens.svg": 36631,
	"./turnips.svg": 97840,
	"./vegetable.svg": 2316,
	"./vinegar.svg": 40011,
	"./waffles.svg": 60953,
	"./walnuts.svg": 96937,
	"./wasabi.svg": 81466,
	"./watercress.svg": 99852,
	"./watermelon.svg": 98667,
	"./whitemushrooms.svg": 72301,
	"./whitepotato.svg": 56875,
	"./wholegrain.svg": 96587,
	"./wine.svg": 36570,
	"./yams.svg": 84223,
	"./yogurt.svg": 9515,
	"./zucchini.svg": 11886
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58301;